import React, { useState, useEffect } from "react"

import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import TextField from "@material-ui/core/TextField"
import Divider from "@material-ui/core/Divider"
import Button from "@material-ui/core/Button"
import CircularProgress from "@material-ui/core/CircularProgress"

import useDefaultStyles from "../../../styles/default"

import api from "../../../services/api"
import { useValidation } from "../../../services/validation"
import { useNavigation } from "../../../services/navigation"

import { isMobile } from "../../../utils/device"
import { forceLowerCase } from "../../../utils/sanitization"
import { submitOnPressEnter } from "../../../utils/submit"

import Notification from "../../../components/Notification"
import InfoModal from "../../../components/InfoModal"

const RequestRecovery = () => {
	const { getRouteParams } = useNavigation()

	const { hash } = getRouteParams()

	const inputs = ["email"]
	const [validation, clearValidation, triggerValidation] = useValidation(inputs)

	const defaultClasses = useDefaultStyles()

	const [email, setEmail] = useState("")
	const [loading, setLoading] = useState(false)

	const handleLogin = async () => {
		setLoading(true)

		try {
			await api.post(`/home/hash/${hash}/password/recovery`, { email })

			if (isMobile()) {
				Notification.success("Email de redefinição de senha enviado com sucesso!")
			} else {
				InfoModal.success({
					title: "Redefinição de senha",
					message: "Email de redefinição de senha enviado com sucesso!"
				})
			}
		} catch (error) {
			triggerValidation(error)
		}

		setLoading(false)
	}

	const handleChangeEmail = (value) => {
		setEmail(value)
		clearValidation("email")
	}

	useEffect(() => {
		submitOnPressEnter()
	}, [])

	return (
		<Container className={defaultClasses.container}>
			<Typography variant="h6">
				Recuperação de Senha
			</Typography>

			<Typography variant="subtitle1">
				Coloque seu e-mail abaixo para receber uma mensagem com as instruções de recuperação de senha.
			</Typography>

			<Divider className={defaultClasses.invisibleDividerMedium} />

			<TextField
				required
				label="Email"
				variant="standard"
				color="secondary"
				size="small"
				value={forceLowerCase(email)}
				error={!!validation.email.validateStatus}
				helperText={validation.email.help}
				onChange={({ target }) => handleChangeEmail(target.value)}
			/>

			<Divider className={defaultClasses.invisibleDividerMedium} />

			<Button
				variant="contained"
				color="secondary"
				className={defaultClasses.buttonBlock}
				onClick={() => handleLogin()}
				disabled={loading}
				endIcon={loading && <CircularProgress size={20} />}
				id="submit"
			>
				Recuperar senha
			</Button>
		</Container>
	)
}

export default RequestRecovery